import { useI18n } from "../i18n/I18nProvider";
import { IconBullet } from "./icons";

/**
 * Frame 5:39: a 72px padded band in the shared page container, the drone photo on the left and the white card on the right sharing the
 * row in the 720:531 ratio of the design with a 56px gutter, both 456px tall. The card centres its copy vertically with 36px side padding, every
 * line is right-aligned in Arabic, and the bullet glyph sits at the right edge.
 */
export function LocationSection() {
  const { copy, direction } = useI18n();
  const t = copy.location;

  return (
    <section className="bg-surface-3" aria-labelledby="location-title">
      <div
        dir="ltr"
        className="flex flex-col gap-4 mx-auto w-full max-w-[1440px] px-[18px] lg:px-[72px] py-[30px] lg:flex-row lg:gap-14 lg:py-[72px]"
      >
        <img
          src="/media/location-drone.webp"
          alt={t.title}
          width={720}
          height={456}
          data-reveal
          className="h-[240px] w-full shrink-0 rounded-[18px] object-cover lg:h-[456px] lg:min-w-0 lg:flex-[720_1_0%] lg:rounded-[22px]"
        />
        <div
          dir={direction}
          data-reveal
          className="flex flex-col justify-center rounded-[20px] bg-white px-6 py-[30px] shadow-location lg:h-[456px] lg:min-w-0 lg:flex-[531_1_0%] lg:px-9 lg:py-0"
        >
          <h2
            id="location-title"
            className="text-[25px] font-bold leading-[34px] text-navy lg:text-[32px] lg:leading-[60px]"
          >
            {t.title}
          </h2>
          <p className="mt-[18px] text-[13px] leading-[21px] text-body lg:mt-5 lg:text-[15px] lg:leading-[25px]">
            {t.body}
          </p>
          <ul className="mt-[18px] flex flex-col gap-[13px] lg:mt-5">
            {t.bullets.map((bullet) => (
              <li
                key={bullet}
                className={`flex items-center gap-3 ${direction === "rtl" ? "flex-row-reverse" : ""} text-[13px] font-medium leading-[24px] text-ink lg:text-[14px] lg:leading-[26px]`}
              >
                <span className="min-w-0 flex-1 truncate">{bullet}</span>
                <span className="shrink-0 text-[24px] text-purple">
                  <IconBullet />
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
